module.exports = __webpack_public_path__ + "img/contact_qrcode2.47f68fed.jpg";